module.exports = "/images/ps.svg?1189c3de73b9be6c3494ec629b4e8102";